/**
 * What the toast says when the API refuses a contact. "Failed to add contact.
 * Please try again." hid the reason twice from Madelynn on 11/3; the API's
 * 422 names the field and the rule, so say that.
 */
type ValidationItem = { loc?: unknown[]; msg?: string };

export const CONTACT_REFUSAL_FALLBACK =
  'Failed to add contact. Please try again.';

export function contactRefusalMessage(error: unknown): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })
    ?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const parts = (detail as ValidationItem[])
      .map((item) => {
        const field = String(item.loc?.[item.loc.length - 1] ?? '').trim();
        const msg = (item.msg ?? '')
          .replace(/^value /i, '')
          .replace(/\.+$/, '')
          .trim();
        return field && msg ? `${field}: ${msg}` : msg || field;
      })
      .filter(Boolean);
    if (parts.length) return `Not saved. ${parts.join('; ')}.`;
  }
  return CONTACT_REFUSAL_FALLBACK;
}
